// Vendor imports
const { combineReducers } = require('redux-immutable')
// Sibling imports
const RootRecord = require('./record')

const collectionProfileReducers = {
  // Common state
  ...require('client-v2/common/state/reducers'),
  // Common containers
  articleProfileModal: require('client-v2/common/containers/article-profile/state/modal-reducer'),
  authModal: require('client-v2/common/containers/auth-modal/reducer'),
  collectionSelectModal: require('client-v2/common/containers/collection-select-modal/reducer'),
  confirmModal: require('client-v2/common/containers/confirm-modal/reducer'),
  contentAddModal: require('client-v2/common/containers/content-add-modal/reducer'),
  lightweightEngagementTutorial: require('client-v2/common/containers/lightweight-engagement/containers/tutorial/reducer'),
  searchForm: require('client-v2/common/containers/search-form/reducer'),
  shareModal: require('client-v2/common/containers/share-modal/reducer'),
  toasts: require('client-v2/common/containers/toasts/reducer'),
  tooltips: require('client-v2/common/containers/tooltips/reducer'),
  // Entry containers
  collection: require('../containers/collection/reducer'),
  collectionEditModal: require('../containers/collection-edit-modal/reducer'),
  collectionEditCoverImageModal: require('../containers/collection-edit-cover-image-modal/reducer'),
  collectionEditHeaderImageModal: require('../containers/collection-edit-header-image-modal/reducer'),
  feed: require('../containers/feed/reducer')
}

module.exports = combineReducers(
  collectionProfileReducers,
  () => new RootRecord()
)
